export const uploadSummaryFields = {
  name: 'string',
  lastModified: 'date'
};
